import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const adminService = {
  async loginAdmin(email, password) {
    try {
      const response = await axios.post(`${API_URL}/admins/login`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async registerAdmin(email, password) {
    try {
      const response = await axios.post(`${API_URL}/admins/register`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default adminService;
